import React, { useState, useEffect } from "react";
import "./Infos.css";
import { getNewsData, updateNewsData, deleteNewsData } from "../../controllers/NewsController";
import { FaPlus, FaTrashAlt, FaRegSave } from "react-icons/fa";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import ButtonWithMenu from "../Shared/ButtonWithMenu/ButtonWithMenu";
import { IconButton } from "@mui/material";

function Infos() {
  const [isLoading, setIsLoading] = useState(true);
  const pagelogo = "server/templates/booyakasha";
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [sections, setSections] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const options = [{ title: "Texte", subOptions: undefined }, { title: "Vidéo", subOptions: undefined }];

  useEffect(() => {
    getNewsData("info").then((data) => {
      if (data) {
        if (data.sections.length > 0) {
          setSections(data.sections);
        } else {
          setInitialOption();
        }
      }
      setIsLoading(false);
    });
  }, []);

  const updateInfos = () => {
    const data = { logo: pagelogo, sections: sections };
    updateNewsData("info", data).then(() => {
      setHasUnsavedChanges(false);
    });
  };

  const deleteInfo = () => {
    deleteNewsData("info", currentPage).then((data) => {
      const newSections = [...sections];
      newSections.splice(currentPage, 1);
      if (newSections.length === 0) {
        setInitialOption();
      } else {
        setSections(newSections);
      }
      setCurrentPage(0);
      setHasUnsavedChanges(false);
    })
  }

  const setInitialOption = () => {
    const newSection = { title: "Nouvelle section" };
    newSection.content = " ";
    setSections([newSection]);
  }

  const selectOption = (selectedOption) => {
    const newSection = { title: "Nouvelle section" };
    if (selectedOption === "Texte") {
      newSection.content = " ";
    }
    else if (selectedOption === "Vidéo") {
      newSection.video = { url: "" };
    }
    setSections([...sections, newSection]);
    setCurrentPage(sections.length);
    setHasUnsavedChanges(true);
  };

  const updateTitle = (title) => {
    const newSections = [...sections];
    newSections[currentPage].title = title;
    setSections(newSections);
    setHasUnsavedChanges(true);
  }

  const updateContent = (content) => {
    const newSections = [...sections];
    newSections[currentPage].content = content;
    setSections(newSections);
    setHasUnsavedChanges(true);
  }

  const updateVideo = (video) => {
    const newSections = [...sections];
    newSections[currentPage].video.url = video;
    setSections(newSections);
    setHasUnsavedChanges(true);
  }

  const formatYoutubeUrl = (url) => {
    const videoId = url.split("v=")[1];
    return `https://www.youtube.com/embed/${videoId}`;
  };

  const handlePageChange = (index) => {
    setCurrentPage(index);
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="page-container">
      <h1 className="page-title">Infos</h1>
      <div className="card-container info">
        <div className="card-text-input">
          <span className="text-label">Titre:</span>
          <input
            type="text"
            className="input-text"
            value={sections[currentPage].title}
            onChange={(e) => updateTitle(e.target.value)}
          />
        </div>

        {sections[currentPage].content && (
          <textarea
            type="text"
            className="card-text-area"
            value={sections[currentPage].content}
            onChange={(e) => updateContent(e.target.value)}
          />
        )}
        {sections[currentPage].video && (
          <div className="card-text-input">
            <span className="text-label">Vidéo:</span>
            <input
              type="url"
              className="input-text"
              placeholder="https://www.youtube.com/watch?v=XXXXXXXXX"
              value={sections[currentPage].video.url}
              onChange={(e) => updateVideo(e.target.value)}
              pattern="https:\/\/www\.youtube\.com\/watch\?v=[a-zA-Z0-9_-]{11}"
              required
            />
          </div>
        )}
        {sections[currentPage].video && (
          <div className="video-container">
            <iframe
              width="560"
              height="315"
              src={formatYoutubeUrl(sections[currentPage].video.url)}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen>
            </iframe>
          </div>
        )}
        <div className="card-footer">
          <div className="footer-options">
            <ButtonWithMenu icon={<FaPlus />} options={options} selectOption={selectOption} className="card-button footer-option" disabled={hasUnsavedChanges} />
            <button className="card-button footer-option" disabled={!hasUnsavedChanges} type="submit" onClick={() => updateInfos()}>
              <FaRegSave />
            </button>
            <button className="card-button footer-option" onClick={() => deleteInfo()}>
              <FaTrashAlt />
            </button>
          </div>
          <div className="pagination-container">
            <IconButton disabled={currentPage === 0} onClick={() => handlePageChange(currentPage - 1)}>
              <MdNavigateBefore className="navigation-arrow" />
            </IconButton>
            {sections.map((_, index) => (
              <button
                key={index}
                disabled={hasUnsavedChanges}
                onClick={() => handlePageChange(index)}
                className={`pagination-circle ${currentPage === index ? "active" : ""
                  }`}
              />
            ))}
            <IconButton disabled={currentPage === sections.length - 1} onClick={() => handlePageChange(currentPage + 1)}>
              <MdNavigateNext className="navigation-arrow" />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Infos;
